import { AxiosFetcher } from './AxiosFetcher'

export const fetcher = new AxiosFetcher()

export type { IFetcher } from './IFetcher'
export * from './api.types'
export * from './defaultBaseUrl'
